import {createAvatar} from '@dicebear/avatars';
import * as style from '@dicebear/avatars-bottts-sprites';


const setAvatar = function () {
    $('.needAvatar').each(function (index) {
        const item = $(this);
        const hash = $(this).data('hash');

        const el = createAvatar(style, {
            seed: hash.toString(),
            radius: 48
        });
        item.html(el);
        item.removeClass('needAvatar');
    });
};

export default setAvatar;
